// Handle activating and scrolling to the correct tab based on the URL hash
function activateTab(hash, scrollBehavior) {
  var trigger = document.querySelector('[data-bs-target="#purchase-' + hash + '"]');
  if (!trigger) return false;
  new bootstrap.Tab(trigger).show();
  var section = trigger.closest('.purchase-options-tabs');
  if (section) section.scrollIntoView({ behavior: scrollBehavior, block: 'start' });
  return true;
}

// Handle opening and scrolling to the correct FAQ accordion based on the URL hash
function activateAccordion(hash, scrollBehavior) {
  if (hash.indexOf('faq-') !== 0) return false;
  var accordion = document.getElementById(hash);
  if (!accordion) return false;
  var toggle = accordion.querySelector('.accordion-toggle');
  if (toggle && !accordion.classList.contains('is-open')) toggle.click();
  accordion.scrollIntoView({ behavior: scrollBehavior, block: 'start' });
  return true;
}

// Activates the tab or accordion matching the given hash and scrolls to it with the specified behavior
function activateTarget(hash, scrollBehavior) {
  if (!hash) return;
  activateTab(hash, scrollBehavior) || activateAccordion(hash, scrollBehavior);
}

function activateTargetFromHash(scrollBehavior) {
  activateTarget(window.location.hash.replace('#', ''), scrollBehavior);
}

// Instant scroll if the page is loaded with a hash in the URL
document.addEventListener('DOMContentLoaded', function () {
  activateTargetFromHash('instant');
});

// Smooth scroll when the hash changes in the URL for in-page linking
window.addEventListener('hashchange', function () {
  activateTargetFromHash('smooth');
});

// Handles case where the hash doesn't change (e.g. already on #self, clicking a #self or #faq-* link again)
document.querySelectorAll('a[href^="#self"], a[href^="#team"], a[href^="#faq-"]').forEach(function (link) {
  link.addEventListener('click', function () {
    activateTarget(link.getAttribute('href').replace('#', ''), 'smooth');
  });
});

// Update the URL hash when a tab is shown for bookmarking
document.querySelectorAll('[data-bs-toggle="tab"]').forEach(function (btn) {
  btn.addEventListener('shown.bs.tab', function (e) {
    var hash = e.target.getAttribute('data-bs-target').replace('#purchase-', '');
    history.replaceState(null, '', '#' + hash);
  });
});
